import { TradeInEvent } from '../interfaces/interface.shift-digital-analytics';
import EventBus from '../services/service.eventBus';
import { state as shiftDigitalState } from '../store/store.tracking-shift-digital';
import { shiftDigitalTradeInEvent } from '../tracking/tracking.shift-digital';
import cookieHelper from '../utils/utils.cookie';
import { getRandomGuid } from '../utils/utils.funnel-component';
import { SD_EVENTS, SHIFT_DIGITAL_ANALYTICS_EVENT, SHIFT_DIGITAL_ANALYTICS_LOAD_SUCCESS_EVENT, getShiftDigitalScriptUrl } from '../utils/utils.shift-digital-analytics';

export const onShiftDigitalAnalyticsInit = (container, oemDealerCode) => {
  if (container && oemDealerCode) {
    try {
      const shiftDigitalBaseUrl = process.env.SHIFT_DIGITAL_BASE_URL;

      const containerScriptSrc = getShiftDigitalScriptUrl(shiftDigitalBaseUrl, container);
      if (!containerScriptSrc) {
        console.log(`Error: No script URL found for container "${container}" with base URL "${shiftDigitalBaseUrl}" and OEM dealer code "${oemDealerCode}"`);
        return;
      }

      if (addScriptShiftDigital(containerScriptSrc)) {
        window['sd'] =
          window['sd'] ||
          function () {
            window['sd']['q'] = window['sd']['q'] || [];
            window['sd']['q'].push(arguments);
          };
        window['sd']['l'] = Date.parse(new Date().toISOString());
        window['sd']('create', container, oemDealerCode, 'KELLEYBLUEBOOKICO');

        window['sd']('getSessionId', (sdSessionId) => {
          const provider = 'KELLEYBLUEBOOKICO';

          const shouldFireTradeInImpression = !cookieHelper.get('SessionId');
          let sessionId;
          if (shouldFireTradeInImpression) {
            sessionId = getRandomGuid();
            cookieHelper.set('SessionId', sessionId);
          } else {
            sessionId = cookieHelper.get('SessionId');
          }
          shiftDigitalState.tradeInSessionId = sessionId;
          shiftDigitalState.sdSessionId = sdSessionId;
          shiftDigitalState.tradeInProvider = provider;
          shiftDigitalState.isSDLoaded = true;
          EventBus.publish(SHIFT_DIGITAL_ANALYTICS_LOAD_SUCCESS_EVENT, { tradeInProvider: provider, tradeInSessionId: sessionId });
          EventBus.subscribe(SHIFT_DIGITAL_ANALYTICS_EVENT, onShiftDigitalAnalyticsHandle);
          shiftDigitalTradeInEvent({ events: SD_EVENTS.tradeInImpression });
        });
      }
    } catch (e) {
      shiftDigitalState.isSDLoaded = false;
      console.log(`Error during Shift Digital analytics initialization for container "${container}" and OEM dealer code "${oemDealerCode}":`, e);
    }
  }
};

export const onShiftDigitalAnalyticsRemoved = () => {
  EventBus.unsubscribe(SHIFT_DIGITAL_ANALYTICS_EVENT, onShiftDigitalAnalyticsHandle);
};

const addScriptShiftDigital = (src, location?, forceInclude?) => {
  const scriptExists = document.querySelector(`script[src*="${src}"]`);
  try {
    if (!scriptExists || forceInclude) {
      const appendTo = location || document.getElementsByTagName('script')[0].parentNode;
      const scriptContainer = document.createElement('script');

      scriptContainer.src = src;
      scriptContainer.type = 'text/javascript';
      scriptContainer.async = true;

      appendTo.appendChild(scriptContainer);
      console.log(`Shift Digital script "${src}" added`);
      return true;
    }
  } catch (e) {
    console.log(`Error loading Shift Digital script from source "${src}". Error:`, e);
  }

  return !!scriptExists;
};

export const onShiftDigitalAnalyticsHandle = (event: TradeInEvent) => {
  shiftDigitalTradeInEvent(event);
};